


























import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GExsmDetailCalcSelectModal',
  computed: {},
  methods: {},
})
export default class GExsmDetailCalcSelectModal extends Mixins(GPageBase) {
  showReportTypeModal: boolean = false;

  @Prop({ default: false }) value: boolean;
  @Watch('value')
  openModal(value: boolean) {
    this.showReportTypeModal = value;
  }

  handleIsFixedValue(value: boolean) {
    // 速報値(true)または確定値(false)でスコア計算フラグを立ち上げる
    this.$emit('handleIsFixedValue', value);
  }

  handleCancel() {
    this.$emit('input', false);
  }
}
